export default "__VITE_ASSET__DRJbPeRG__"